import format from '../../currency-formatter';
import PaymentAccountId from '../PaymentAccountId';
import { Icon } from '@zambezi/sdk/icons';
import classNames from 'classnames';
import React from 'react';
import style from './MultiplePayeesTo.module.css';
import text from '../text.module.css';
export default function MultiplePayeesTo(_ref) {
  var payees = _ref.payees,
    isExpanded = _ref.isExpanded,
    onToggle = _ref.onToggle;
  var iconName = isExpanded ? 'minimise-small' : 'expand-small';
  return /*#__PURE__*/React.createElement("div", {
    className: "js-bulk-payees"
  }, /*#__PURE__*/React.createElement("div", {
    className: style.showHidePayees
  }, /*#__PURE__*/React.createElement("button", {
    className: classNames(style.toggle, 'js-view-payees-toggle'),
    onClick: onToggle
  }, /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    className: style.icon
  }), " View payees")), isExpanded && /*#__PURE__*/React.createElement("ol", {
    className: classNames(style.payeesList, 'js-payees-list')
  }, payees.map(function (payee, i) {
    var name = payee.getIn(['creditor', 'account', 'customerName']);
    var amount = payee.get('amountString') || Number(payee.get('amount'));
    var reference = payee.getIn(['paymentInformation', 'statementReference']);
    var creditor = payee.get('creditor');
    var currency = payee.get('currency');
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: classNames(style.payee, "js-payee-item-".concat(i + 1))
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(text.bodyCopy, " ").concat(style.nameAndAmount)
    }, /*#__PURE__*/React.createElement("span", {
      className: "js-payee-name"
    }, name), /*#__PURE__*/React.createElement("span", {
      className: "js-payee-amount"
    }, format(currency, amount))), /*#__PURE__*/React.createElement("div", {
      className: text.annotationSmall
    }, /*#__PURE__*/React.createElement(PaymentAccountId, {
      accountId: creditor,
      className: "js-payee-account-details"
    }), reference && /*#__PURE__*/React.createElement("span", {
      className: classNames(style.reference, 'js-payee-ref')
    }, "Ref: ", reference)));
  })));
}